import AnalyticsStore from 'stores/analytics/analyticsStore';
import pageDataObject from 'application/pageDataObject';
import { queryString, } from 'utils/window';
import ua from 'utils/ua';


const ANALYTICS_SERVICE_FOR_DOMAIN = [
  {
    condition: () => true,
    services: {
      '90min': ['quantcast', 'comscore', 'affiliates', 'actionCounter', 'googleAnalytics', ],
      ftb90: ['affiliates', 'actionCounter', 'googleAnalytics', ],
      '12up': ['affiliates', 'actionCounter', 'googleAnalytics', 'comscore', ],
      'dbltap': ['affiliates', 'actionCounter', 'googleAnalytics', 'comscore',],
    },
  },
  {
    condition: () => pageDataObject.isSlideshow && ua.isNativeApp,
    services: {
      '90min': ['cooladataNativeApp', ],
      ftb90: ['cooladataNativeApp', ],
      '12up': [],
    },
  },
  {
    condition: () => !ua.isNativeApp,
    services: {
      '90min': ['cooladata', 'agof', ],
      ftb90: ['cooladata', ],
      '12up': ['cooladata', ],
      'dbltap': ['cooladata',],
    },
  },
  {
    condition: () => !ua.isNativeApp && pageDataObject.get('config.facebook_pixel') && !queryString.a_aid,
    services: {
      '90min': ['facebookAnalytics', ],
      ftb90: ['facebookAnalytics', ],
      '12up': ['facebookAnalytics', ],
      'dbltap': ['facebookAnalytics',],
    },
  },
  {
    condition: () => ua.path.isFullLayout,
    // condition: () => ua.path.isFullLayout && pageDataObject.isQaEnv,
    services: {
      '90min': ['bigQueryProxy', ],
      ftb90: [],
      '12up': ['bigQueryProxy', ],
      'dbltap': ['bigQueryProxy',],
    },
  },
];

const analyticsServices = [];
for (const config in ANALYTICS_SERVICE_FOR_DOMAIN) {
  const { condition, services } = ANALYTICS_SERVICE_FOR_DOMAIN[config];
  if (condition()) {
    const domainServices = services[ua.domainFromFqdn] || [];
    for (const service of domainServices) {
      analyticsServices.push(require(`services/analytics/${ service }Service`));
    }
  }
}

const analyticsStore = AnalyticsStore.create();

export default function init(){
  analyticsServices.forEach(function(Class){
    Class.create({ store: analyticsStore, });
  });
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/analyticsInitializer.js